<template>
  <Modal v-model="batchConfigLabelModal" :title="$t('key1001441')" width="500" :transfer="false"
    :mask-closable="false" @on-visible-change="batchConfigLabelChange">
    <Form ref="batchConfigLabelForm" :model="batchConfigLabelForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 80%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item class="radio_styles" :label="$t('key1000930')" prop="operationType">
            <RadioGroup v-model="batchConfigLabelForm.operationType">
              <Radio :label="0">{{ $t('key1001443') }}</Radio>
              <Radio :label="1">{{ $t('key1001444') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001442')" prop="ymsLabelIds">
            <Select v-model="batchConfigLabelForm.ymsLabelIds" filterable multiple :placeholder="$t('key1001440')">
              <Option v-for="item in labelsList" :value="item.ymsLabelId">{{ item.labelName }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="batchConfigLabelModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="batchConfigLabelBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "batchConfigLabelModal",
  mixins: [Mixin],
  props: {
    // 配置类型
    configurationType: {
      type: String,
      default: 'customer' // 商品：commodity、客户：customer
    },
    // 是否自营商品
    selfOperatedProducts: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let v = this;
    return {
      batchConfigLabelModal: false,
      batchConfigLabelForm: {
        ids: [],
        operationType: 0,
        ymsLabelIds: []
      },
      ruleValidate: {
        ymsLabelIds: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001440'), trigger: 'change', type: 'array'}
        ]
      },
      labelsList: []
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initBatchConfigLabelData(selectTableData, data) {
      if (this.configurationType === 'commodity') {
        data.map((item) => {
          item.ymsLabelId = item.ymsProductTagId;
          item.labelName = item['productLabel_' + this.languagesVal];
        });
        this.batchConfigLabelForm.ids = selectTableData.map((item) => {
          return item.ymsProductId;
        });
      } else {
        this.batchConfigLabelForm.ids = selectTableData.map((item) => {
          return item.ymsMerchantId;
        });
      }
      this.labelsList = data;
      this.batchConfigLabelModal = true;
    },
    // 保存按钮
    batchConfigLabelBtn() {
      let v = this;
      let url = '';
      let query = {};
      if (v.configurationType === 'commodity') {
        url = v.selfOperatedProducts ? api.post_ymsProductInfoCore_batchSetProductTagRelated : api.post_productInfo_batchSetProductTagRelated;
        query = {
          ymsProductIds: v.batchConfigLabelForm.ids,
          ymsProductTagIds: v.batchConfigLabelForm.ymsLabelIds,
          opType: v.batchConfigLabelForm.operationType + 1,
        };
      } else {
        url = api.post_ymsDistributorMerchant_configurationTabs;
        query = v.batchConfigLabelForm;
      }
      v.$refs['batchConfigLabelForm'].validate((valid) => {
        if (valid) {
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
              v.$emit('updateData', true);
              v.batchConfigLabelModal = false;
            }
          });
        }
      });
    },
    // 监听弹窗
    batchConfigLabelChange(value) {
      let v = this;
      if (!value) {
        v.$nextTick(() => {
          v.$refs['batchConfigLabelForm'].resetFields();
          v.batchConfigLabelForm.ids = [];
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>